import React, { useRef } from 'react';
import {
  ApplicationView,
  useController,
  StartControllerScope,
} from '@aha-app/mvc';
import styles from './HistoryPanel.module.css';
import toolStyles from '../ToolPanel/ToolPanel.module.css';
import AssistantViewController from '../AssistantView/AssistantViewController';
import HistoryController from './HistoryController';
import useInfiniteScroll from 'components/bookmark_audits_sidebar/InfiniteScroll';
import { AhaSearchField } from 'components/common/reactifyWebComponent';

const HistoryPanel = () => {
  const assistantController = useController<AssistantViewController>(
    AssistantViewController
  );
  const { size, model } = assistantController.state;
  const historyController = useController<HistoryController>();
  const { hasMore, chats } = historyController.state;
  const spinnerRef = useRef(null);
  const scrollerRef = useRef(null);

  useInfiniteScroll({
    targetRef: spinnerRef,
    rootRef: scrollerRef,
    hasMore,
    loadMore: () => historyController.actionLoadMoreChats(),
  });

  return (
    <div className={styles.historyPanel}>
      {['full-screen', 'full-page'].includes(size) && (
        <div className={toolStyles.toolPanelHeader}>
          <div className={toolStyles.toolPanelName}>Chat history</div>
          <div className={toolStyles.toolPanelHeaderTools}>
            <aha-button
              kind='icon'
              size='mini'
              onClick={() => assistantController.actionShowToolPanel(null)}
            >
              <i className='far fa-xmark' />
            </aha-button>
          </div>
        </div>
      )}
      <AhaSearchField
        className={styles.historyPanelSearch}
        placeholder='Search'
        throttled={false}
        onInput={event =>
          historyController.actionSearchChats(event.target.value)
        }
      />
      <div className={styles.historyPanelContent} ref={scrollerRef}>
        <div className={styles.historyPanelItems}>
          {chats.map(chat => (
            <aha-menu-item
              class={styles.historyPanelItem}
              selected={chat.id === model.currentChat?.id ? true : undefined}
              key={chat.id}
              onClick={() => assistantController.actionShowChat(chat)}
            >
              <span className={styles.historyPanelItemTitle}>{chat.name}</span>
            </aha-menu-item>
          ))}
          {hasMore && <aha-loading-row ref={spinnerRef} kind='list' rows={5} />}
        </div>
      </div>
    </div>
  );
};

export default StartControllerScope(
  HistoryController,
  ApplicationView(HistoryPanel)
);
